import { Component, OnInit } from '@angular/core';
import { iframeEntryUrl } from '../../../_utils/iframe-url';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  showPopup = false;
  iframeURL = iframeEntryUrl();

  constructor() { }

  ngOnInit(): void {
  }

  openPage(page: string): void {
    switch (page) {
      case 'artist':
        this.iframeURL = iframeEntryUrl('/tabs/explore');
        break;
      case 'industry':
        this.iframeURL = iframeEntryUrl('/tabs/explore?tab=industry');
        break;
      case 'gigfunders':
        this.iframeURL = iframeEntryUrl('/tabs/public-campaigns');
        break;
      case 'shows':
        this.iframeURL = iframeEntryUrl('/tabs/shows');
        break;
      case 'gigs':
        this.iframeURL = iframeEntryUrl('/tabs/gigs');
        break;
      case 'fans':
        this.iframeURL = iframeEntryUrl();
        break;
      case 'faq':
        this.iframeURL = iframeEntryUrl('/faqs');
        break;
      case 'terms':
        this.iframeURL = iframeEntryUrl('/terms');
        break;
      case 'conduct':
        this.iframeURL = iframeEntryUrl('/rules');
        break;
      case 'privacy':
        this.iframeURL = iframeEntryUrl('/privacy');
        break;
      default:
        break;
    }
    this.showPopup = true;
  }

  getDynamicClass(): any {
    return {
      'custom-phone-device ios': true,
    };
  }

}
